import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MapService } from 'src/app/services/map.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-bottomnavigation',
  templateUrl: './bottomnavigation.component.html',
  styleUrls: ['./bottomnavigation.component.scss'],
})
export class BottomnavigationComponent implements OnInit {
  @Input() selectedIcon = '';
  showFooter = true;
  ordersIcon = '../../../../assets/orders.svg';
  mapIcon = '../../../../assets/map.svg';

  constructor(
    private router: Router,
    private storageService: StorageService,
    private changeDetectorRef: ChangeDetectorRef,
    private mapService: MapService,
    private translateService: TranslateService,
    private alertController: AlertController
  ) {}

  ngOnInit() {
    this.checkSelectedIcon(this.selectedIcon);
    const self = this;
    window.addEventListener('native.keyboardshow', keyboardShowHandler);
    function keyboardShowHandler() {
      self.showFooter = false;
    }
    window.addEventListener('native.keyboardhide', keyboardHideHandler);
    function keyboardHideHandler() {
      self.showFooter = true;
    }
  }

  checkSelectedIcon(selectedIcon: any) {
    if (selectedIcon === 'orders') {
      this.ordersIcon = '../../../../assets/orders-selected.svg';
    }
    if (selectedIcon === 'map') {
      this.mapIcon = '../../../../assets/map-selected.svg';
    }
  }

  async changeScreen(newScreen: any) {
    if (newScreen === this.selectedIcon) {
      return;
    }
    if (newScreen === 'orders') {
      this.router.navigate(['/orders']);
    }
    if (newScreen === 'map') {
      if (this.mapService.claimedOrders.length > 0) {
        this.checkForPermissions();
        this.router.navigate(['/current-order']);
      } else {
        const noClaimedOrders =
          this.translateService.instant('no-claimed-orders');
        const noClaimedOrdersText = this.translateService.instant(
          'no-claimed-orders-text'
        );
        const okay = this.translateService.instant('okay');
        const alert = await this.alertController.create({
          header: noClaimedOrders,
          message: noClaimedOrdersText,
          buttons: [okay],
        });

        await alert.present();
      }
    }
  }

  async checkForPermissions() {
    await this.mapService.checkForPermissions();
    this.changeDetectorRef.detectChanges();
  }
}
